"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_localize_redux_1 = require("react-localize-redux");
var core_1 = require("@material-ui/core");
var FormQuestion_1 = require("./FormQuestion");
var elementStateUtils_1 = require("../../elementStateUtils");
var constants_1 = require("../../constants");
var styles = function (theme) { return ({
    validationText: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
        width: '100%',
        outline: 'none',
    },
}); };
var FormValidation = /** @class */ (function (_super) {
    __extends(FormValidation, _super);
    function FormValidation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            missingRequiredQuestions: false,
            changeId: null,
        };
        _this.validationErrorRef = React.createRef();
        _this.validate = function () {
            var _a;
            var _b = _this.props, task = _b.task, responses = _b.responses, getProgramItem = _b.getProgramItem, getSpecificTaskResponses = _b.getSpecificTaskResponses, changeId = _b.changeId;
            if (!((_a = task.contentElements) === null || _a === void 0 ? void 0 : _a.length)) {
                return true;
            }
            var missingRequiredQuestions = task.contentElements.map(function (e) {
                var _a;
                var contentState = (0, elementStateUtils_1.getElementConditionState)(e, getSpecificTaskResponses, task, getProgramItem);
                if ((contentState === null || contentState === void 0 ? void 0 : contentState.state) === constants_1.elementConditionStates.hidden) {
                    return false;
                }
                return (_a = e.questions) === null || _a === void 0 ? void 0 : _a.reduce(function (prev, curr) {
                    var _a;
                    return prev
                        || (curr.required && (!responses || !(0, FormQuestion_1.hasValueForQuestionType)(curr.type, (_a = responses[curr.id]) === null || _a === void 0 ? void 0 : _a.response)));
                }, false);
            }).some(function (d) { return d; });
            _this.setState({ missingRequiredQuestions: missingRequiredQuestions, changeId: changeId });
            return !missingRequiredQuestions;
        };
        return _this;
    }
    FormValidation.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Focus on validation error when appearing
        if (!prevState.missingRequiredQuestions && this.state.missingRequiredQuestions) {
            if (this.validationErrorRef.current)
                this.validationErrorRef.current.focus();
        }
        if (prevState.missingRequiredQuestions && this.props.changeId && prevState.changeId !== this.props.changeId) {
            this.validate();
        }
    };
    FormValidation.prototype.render = function () {
        var _a = this.props, classes = _a.classes, task = _a.task, showValidations = _a.showValidations;
        if (!task) {
            return null;
        }
        if (!this.state.missingRequiredQuestions || !showValidations) {
            return null;
        }
        return (React.createElement(core_1.Typography, { color: "error", tabIndex: -1, ref: this.validationErrorRef, className: classes.validationText },
            React.createElement(react_localize_redux_1.Translate, { id: "taskContent.pleaseAnswerRequiredQuestions" })));
    };
    return FormValidation;
}(React.Component));
// @ts-ignore // Typescript doesn't recognise defaultProps for Class Components??
FormValidation.defaultProps = {
    showValidations: false,
    responses: null,
    changeId: null,
    ref: null,
};
exports.default = (0, core_1.withStyles)(styles)(FormValidation);
